let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kNg9U")).then(() => parcelRequire('krf2j'));